<template>
	<div class="mt-8 w-full flex justify-center items-center">
		<Loading
			:is-full-page="isFullPage"
			:style="!isFullPage ? 'position: relative' : ''"
			:height="height"
			:active.sync="isLoading"
			:can-cancel="false"
			color="#0068B4"
			background-color="#000000"
			:opacity="isFullPage ? 0.5 : 0.0"
		/>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';

export default {
	name: 'LoadingSpinner',
	components: { Loading },
	props: {
		isFullPage: { type: Boolean, default: false },
		height: { type: Number, default: 62 },
	},
	data() {
		return {
			isLoading: true,
		};
	},
};
</script>

<style scoped></style>
